module.exports = __webpack_public_path__ + "static/media/keyword.fdad43af.png";